import React, { Fragment } from 'react'
import { Box, Tabs } from 'stylist'
import withCompany from 'components/withCompany'
import FeatureFlag from 'components/FeatureFlag'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import RelationshipContainer from 'components/RelationshipContainer'
import fields from 'fields/companies'
import { Switch, Route } from 'react-router-dom'
import RouteCompanyUsers from './users'
import RouteUsersManage from './users/manage'
import RoutePrimaryUserManage from './primary_user/manage'
import RouteCompanyUsersNew from 'routes/admin/companies/users/new'
import RouteCompanyPrimaryUserNew from 'routes/admin/companies/primary_user/new'
import RouteCompanyPlans from 'routes/admin/companies/plans'
import RouteCompanyPlansNew from 'routes/admin/companies/plans/new'
import PrimaryUser from './primary_user'
import renderValue from 'utils/renderValue'

const RouteShow = ({ company, match: { path } }) => (
  <Fragment>
    <h5>Company Information</h5>
    <Box>
      <Box.Item pad>
        {fields.map(field => (
          <InfoGroup key={field.name}>
            <Subheader>{field.label || field.name}:</Subheader>
            <span>{renderValue(company[field.name])}</span>
          </InfoGroup>
        ))}
      </Box.Item>
    </Box>
    <Tabs>
      <Tabs.Item to={`${path}/users`}>Users</Tabs.Item>
      <Tabs.Item to={`${path}/primary_user`}>Primary User</Tabs.Item>
      <FeatureFlag
        name="admin_plan_create"
        active={() => <Tabs.Item to={`${path}/plans`}>Plans</Tabs.Item>}
      />
    </Tabs>
    <RelationshipContainer>
      <Switch>
        <Route
          path={`${path}/users`}
          exact
          render={routeProps => (
            <RouteCompanyUsers
              variables={{ company_id: company.id }}
              {...routeProps}
            />
          )}
        />
        <Route
          path={`${path}/users/new`}
          exact
          render={routeProps => (
            <RouteCompanyUsersNew company={company} {...routeProps} />
          )}
        />
        <Route
          path={`${path}/users/manage`}
          exact
          render={() => (
            <RouteUsersManage
              company={company}
              variables={{ company_id: company.id, show_has_company: true }}
            />
          )}
        />
        <Route
          path={`${path}/primary_user/manage`}
          exact
          render={() => (
            <RoutePrimaryUserManage
              company={company}
              variables={{ company_id: company.id }}
            />
          )}
        />
        <Route
          path={`${path}/primary_user`}
          exact
          render={() => <PrimaryUser company={company} />}
        />
        <Route
          path={`${path}/primary_user/new`}
          exact
          render={routeProps => (
            <RouteCompanyPrimaryUserNew company={company} {...routeProps} />
          )}
        />
        <FeatureFlag
          name="admin_plan_create"
          active={() => (
            <Fragment>
              <Route
                path={`${path}/plans`}
                exact
                render={() => <RouteCompanyPlans company={company} />}
              />
              <Route
                path={`${path}/plans/new`}
                exact
                render={routeProps => (
                  <RouteCompanyPlansNew company={company} {...routeProps} />
                )}
              />
            </Fragment>
          )}
        />
      </Switch>
    </RelationshipContainer>
  </Fragment>
)

export default withCompany(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/show.js